import React from "react";
import { LatestItemsLoaderTemplate } from "themes/administration/device-menu/components";

function LatestItemsLoader(props) {
    return <LatestItemsLoaderTemplate {...props} />;
}

export default LatestItemsLoader;
